<ng-container *ngIf="introDone; else IntroOngoing">
  <!-- <app-ws></app-ws> -->
  <router-outlet></router-outlet>
</ng-container>
<ng-template #IntroOngoing>
  <app-intro (introDone)="onIntroDone($event)"></app-intro>
</ng-template>

<app-mm></app-mm>
<app-loading></app-loading>
<app-hint></app-hint>
<app-so></app-so>
